import axiosInstance, { publicAxiosInstance } from './AxiosService';

const getBlogPosts = async () => {
  try {
    console.log('BlogService: Fetching all blog posts');
    const response = await publicAxiosInstance.get('blog/');
    console.log('BlogService: Successfully fetched blog posts:', response.data.length);
    return response.data;
  } catch (error) {
    console.error('BlogService: Error fetching blog posts:', error);
    throw error;
  }
};

const getBlogPostBySlug = async (slug) => {
  try {
    console.log(`BlogService: Fetching blog post with slug: ${slug}`);
    const response = await publicAxiosInstance.get(`blog/${slug}/`);
    console.log(`BlogService: Successfully fetched blog post: ${response.data.title}`);
    return response.data;
  } catch (error) {
    console.error(`BlogService: Error fetching blog post with slug ${slug}:`, error);
    throw error;
  }
};

const createBlogPost = async (postData) => {
  try {
    console.log('BlogService: Creating new blog post:', postData.title);
    const response = await axiosInstance.post('blog/', postData);
    console.log('BlogService: Successfully created blog post:', response.data);
    return response.data;
  } catch (error) {
    console.error('BlogService: Error creating blog post:', error);
    throw error;
  }
};

const updateBlogPost = async (id, postData) => {
  try {
    console.log(`BlogService: Updating blog post with id: ${id}`);
    const response = await axiosInstance.put(`blog/id/${id}/`, postData);
    console.log(`BlogService: Successfully updated blog post: ${response.data.title}`);
    return response.data;
  } catch (error) {
    console.error(`BlogService: Error updating blog post with id ${id}:`, error);
    throw error;
  }
};

const deleteBlogPost = async (id) => {
  try {
    console.log(`BlogService: Deleting blog post with id: ${id}`);
    await axiosInstance.delete(`blog/id/${id}/`);
    console.log(`BlogService: Successfully deleted blog post with id: ${id}`);
    return true;
  } catch (error) {
    console.error(`BlogService: Error deleting blog post with id ${id}:`, error);
    throw error;
  }
};

export const BlogService = {
  getBlogPosts,
  getBlogPostBySlug,
  createBlogPost,
  updateBlogPost,
  deleteBlogPost
};

export default BlogService; 